import Swiper from 'swiper/bundle';
import ImageCompare from 'image-compare-viewer';

export const slide = {
    viewers: [],
    init: ()=>{
        if(document.getElementById('main').classList.contains('single-work')){
            const swiper = new Swiper('.swiper', {
                // Optional parameters
                loop: true,
                
                // If we need pagination
                pagination: {
                    el: '.swiper-pagination'
                }
            });

            //画像比較
            slide.viewers = document.querySelectorAll('.image-compare');
            if(slide.viewers){
                slide.viewers.forEach((elm) => {
                    let view = new ImageCompare(elm).mount();
                });
            }
        }
    }
}